module.exports = __webpack_public_path__ + "static/media/gaizao-renminzhengfu.9ba734e9.png";